import React from 'react';
import { Box, Typography, Button, CircularProgress } from '@mui/material';
import './styles.scss';

/**
 * Uma tela que o usuario pode acessar, com o codigo do submenu em destaque e
 * atalho para abri-la.
 *
 * O codigo e o dado mais util da conversa (e o que se digita na busca do
 * sistema), por isso vem em fonte monoespacada e com realce proprio.
 *
 * Puramente apresentacional: quem sabe navegar e o useListaTelasHook.
 */
export default function CardTela({ tela, destacado, aoAbrir, abrindo }) {
  return (
    <Box className={`chat-ia-card-tela ${destacado ? 'chat-ia-card-tela-destacado' : ''}`}>
      <Box className="chat-ia-card-tela-info">
        <Typography className="chat-ia-card-tela-nome">{tela.tela}</Typography>
        <Typography className="chat-ia-card-tela-codigo" variant="caption">
          Submenu <span className="chat-ia-card-tela-chip">{tela.cod_submenu}</span>
        </Typography>
      </Box>

      <Button
        className="chat-ia-card-tela-abrir"
        onClick={() => aoAbrir(tela)}
        disabled={abrindo}
        disableRipple
      >
        {abrindo ? <CircularProgress size={14} thickness={5} /> : 'Abrir'}
      </Button>
    </Box>
  );
}
